<template>
    <div class="row">
        <div class="col-lg-12">
            <div class="col-12">
                <h1 class="title-tab-content">سفارشات</h1>
            </div>
            <div class="content-section default">
                <div class="row">
                    <div class="col-md-12 col-sm-12">
                        <div class="product-variants default">
                            <div class="radio">
                                <input @change="readOrdersListStateFilter" type="radio" name="radio1" id="radio1" value="1" v-model="ordersListStateFilter" checked="checked">
                                <label for="radio1">
                                    <span class="text">تحویل شده</span>  
                                </label>
                            </div>
                            <div class="radio">
                                <input @change="readOrdersListStateFilter" type="radio" name="radio1" id="radio2" value="2" v-model="ordersListStateFilter">
                                <label for="radio2">
                                    <span  class="text"> در حال انجام</span>
                                </label>
                            </div>
                            <div class="radio">
                                <input @change="readOrdersListStateFilter" type="radio" name="radio1" id="radio3" value="3" v-model="ordersListStateFilter">
                                <label for="radio3">
                                    <span  class="text"> لغو شده</span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 col-xs-12 table-responsive">
                        <table v-if="orderList.length > 0" class="table table-hover table-striped">
                            <thead>
                                <tr>
                                    <th scope="col">ردیف</th>
                                    <th class="date" scope="col">تاریخ/زمان</th>
                                    <th scope="col">مبلغ کل(تومان)</th>
                                    <th scope="col">عملیات</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(order,index) in orderList">
                                    <th scope="row">{{index + 1}}</th>
                                    <td>{{order.RegDateTime}}</td>
                                    <td>{{order.Total | formatNumber}}</td>
                                    <td><router-link :to="{ name:'orderTracking', params: { hashOrderId:  order.Id }}" class="btn btn-default btn-tbl">پیگری سفارشات</router-link></td>
                                </tr>
                            </tbody>
                        </table>
                        <div v-else>
                            <div class="orderListEmpty">
                                <span>سفارشی برای شما ثبت نشده است.</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div :class="{ loader: !isShowSppiner }" style="position:absolute;background-color:#80808033;top:0;bottom:0;left:0;right:0;z-index:9999;width:100%;height:100%"><img style="position:absolute;top:50%;left:50%;z-index:100" src="/assets/img/loader/loader.svg" /></div>
            </div>
        </div>
    </div>
</template>

<script>
    import { httpPromise } from "../../module/httpUtility";
    export default {
        data() {
            return {
                orderList: {},
                ordersListStateFilter: 2,
            }
        },
        methods: {
            readOrdersListStateFilter() {
                this.isShowSppiner = true;
                httpPromise(this, '/v1/Orders/OrdersList/ReadColleagueOrder', 'get', { ordersListStateFilter: this.ordersListStateFilter},
                response => {
                    toastr.remove();
                    this.orderList = response.data.Value;
                    this.isShowSppiner = false;
                },
                response => {
                    toastr.remove();
                    toastr.error(response.data.Message);
                    this.isShowSppiner = false;
                });
            }
        },
        beforeMount() {
            createPageTitle('سفارشات من');
            this.readOrdersListStateFilter();
        }
    }
</script>

<style scoped>
    .content-section {
        min-height:475px;
    }
    .radio .text {
        display: inline-block;
        width: 80px;
    }
    .product-variants .radio label {
        padding-left: 35px;
        padding-right: 0;
    }
    .product-variants .radio {
        margin-right: 50px;
        display: inline-block;
        width: 125px;
    }
        .product-variants .radio input[type="radio"]:checked + label::after {
            width: 10px;
            height: 10px;
            background-color: #3081fb;
            border-color: #3081fb;
            top: 10px;
            left: 130px;
        }
    .radio label::before, .radio label::after {
        content: " ";
        width: 20px;
        height: 20px;
        border-radius: 50%;
        border: 1px solid #E3E3E3;
        display: inline-block;
        position: absolute;
        left: 125px;
        top: 5px;
        padding: 1px;
        -webkit-transition: opacity 0.3s linear;
        -moz-transition: opacity 0.3s linear;
        -o-transition: opacity 0.3s linear;
        -ms-transition: opacity 0.3s linear;
        transition: opacity 0.3s linear;
    }
    .orderListEmpty {
        border: 1px solid #ddd;
        text-align: center;
        border-radius: 5px;
        padding: 20px;
        display: flex;
        justify-content: center;
        flex-direction: column;
        background-color: #fcfcfc;
    }
    table thead tr th, table tbody tr td {
        text-align: center;
    }
    table .btn-tbl {
        margin: 0;
        background-color: #fff;
        border: 1px solid #3871dd;
        color: #3871dd;
    }
    table thead tr th.date {
        width: 250px;
        display: inline-block;
    }
    table thead tr th {
        border: none
    }

</style>